import { useContext, useEffect } from 'react';
import { useRouteMatch } from 'react-router';

import { BreadcrumbContext } from 'packages/kakapo-ui-kit/components/breadcrumb/BreadcrumbContext';

export default function useBreadcrumb(title: string) {
	const { url } = useRouteMatch();
	const { registerBreadcrumb, unregisterBreadcrumb, updateBreadcrumb } = useContext(
		BreadcrumbContext,
	);

	useEffect(() => {
		registerBreadcrumb({ title, to: url });
		return () => {
			unregisterBreadcrumb(url);
		};
	}, [title, url]);

	return { updateBreadcrumb };
}
